module.exports = __webpack_public_path__ + "static/media/hightail-games-logo.96c3e080.png";